<div
  class="flex h-screen w-full items-center justify-center bg-white dark:bg-vivid-royal-950"
>
  <div class="w-full max-w-md px-6 py-10">
    <!-- Logo -->
    <div class="mb-8 text-center">
      <img
        src="./assets/logos/energo_logo.svg"
        class="mx-auto w-40 dark:hidden"
        alt="Logo"
      />
      <img
        src="./assets/logos/energo_logo_dark.svg"
        class="mx-auto w-40 hidden dark:block"
        alt="Logo"
      />
    </div>
    <div class="text-center space-y-4">
      <p class="text-6xl font-bold text-vivid-royal-200 dark:text-vivid-royal-700">404</p>
      <div
        class="w-16 h-16 rounded-full bg-yellow-100 dark:bg-yellow-900/30 flex items-center justify-center mx-auto"
      >
        <i class="pi pi-search text-3xl text-yellow-500"></i>
      </div>
      <h1
        class="text-xl font-semibold text-vivid-royal-700 dark:text-vivid-royal-100"
      >
        Página no encontrada
      </h1>
      <p class="text-sm text-vivid-royal-400 leading-relaxed">
        La dirección que ingresó no existe o fue movida. Verifique la URL o regrese al inicio.
      </p>
      <button pButton label="Ir al inicio" icon="pi pi-home" class="p-button-sm w-full" (click)="goTo('login')"></button>
    </div>
  </div>
</div>
